import {Component, OnInit} from "@angular/core";
import {LookupService} from "../lookup.service";
import {ViewManagerService} from "../../../services/view-manager.service";
import {TranslateService} from "@ngx-translate/core";
import {ChannelDefinition} from "../../../model/channels.model";

@Component({
  selector: "admin-lookup-screening",
  templateUrl: "./screening.component.html",
  styleUrls: ["./screening.component.css"]
})
export class AdminLookupScreeningComponent implements OnInit {

  modalTitle: string;

  constructor(
    private singleService: LookupService,
    private viewManager: ViewManagerService,
    private translate: TranslateService,
  ) {
  }

  ngOnInit() {
    this.singleService.load("wlm", "api")
  }

  get definition(): ChannelDefinition {
    return this.singleService.definition;
  }

  get results() {
    return this.singleService.checksResult;
  }

  show() {
    return this.singleService.channels.length > 0;
  }

  reset() {
    this.singleService.reset("wlm", "api");
  }

  refine() {
    this.singleService.refine();
  }

  lookup() {
    this.singleService.screening();
  }

  report() {
    this.singleService.report();
  }

  showResults() {
    return this.results && this.results.length > 0;
  }

  titleReceiver(title: string) {
    this.modalTitle = title;
  }

}
